
<div class="basicrow m-top m-font">
    <div *ngFor="let categorys of this.category; let i = index" class="basicrow">
        <div data-toggle="collapse" [attr.data-target]="'#tabC_'+i" class="digs-box-f vcenter mob-txt graybg"
            (click)="updateExpand(i)" [ngClass]="{'mon': categorys.expand == true,'': categorys.expand == false,'graybg':this.color==false,'':this.color==true}">
            {{ categorys.value }}
            <i class="fa fa-plus f-right-m" aria-hidden="true"></i>
            <i class="fa fa-minus f-right-m" aria-hidden="true"></i>
        </div>
        <div id="tabC_{{i}}" class="collapse" [ngClass]="{'show': i == 0,'': i > 0}">
            <ng-container >
                <div class="channel-container basicrow allpads bordsdef text-justify mob-txt-a">
                        <div *ngFor="let chanel of this.chanels; let n = index">
                            <div *ngIf="this.plan==1">
                                <div *ngIf="chanel.category==categorys.value" >
                                    <div  class="channel-box" >
                                            <img class="img-box" src="{{chanel.url}}">
                                    </div> 
                                </div>
                            </div>
                            <div *ngIf="this.plan==2">
                                <div *ngIf="chanel.category==categorys.value && chanel.plan=='Basico' " >
                                    <div  class="channel-box" >
                                            <img class="img-box" src="{{chanel.url}}">
                                    </div> 
                                </div>
                            </div>
                            <div *ngIf="this.plan==3">
                                <div *ngIf="chanel.category==categorys.value && chanel.plan=='Premium' " >
                                    <div  class="channel-box" >
                                            <img class="img-box" src="{{chanel.url}}">
                                    </div> 
                                </div>
                            </div>
                            <div *ngIf="this.plan==4">
                                <div *ngIf="chanel.category==categorys.value && chanel.plan=='Adultos' " >
                                    <div  class="channel-box" >
                                            <img class="img-box" src="{{chanel.url}}">
                                    </div> 
                                </div>
                            </div>
                        </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>